var _templateObject = _taggedTemplateLiteral(['\n    @media (max-width: 719px) {\n      ', '\n    }\n  '], ['\n    @media (max-width: 719px) {\n      ', '\n    }\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    @media (max-width: 719px) and (orientation: portrait) {\n      ', '\n    }\n  '], ['\n    @media (max-width: 719px) and (orientation: portrait) {\n      ', '\n    }\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    @media only screen\n    and (min-device-width: 320px)\n    and (max-device-width: 812px)\n    and (orientation: landscape) {\n      ', '\n    }\n  '], ['\n    @media only screen\n    and (min-device-width: 320px)\n    and (max-device-width: 812px)\n    and (orientation: landscape) {\n      ', '\n    }\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    @media (min-width: 720px) and (max-width: 1023px) {\n      ', '\n    }\n  '], ['\n    @media (min-width: 720px) and (max-width: 1023px) {\n      ', '\n    }\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    @media (min-width: 720px) {\n      ', '\n    }\n  '], ['\n    @media (min-width: 720px) {\n      ', '\n    }\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n    @media (min-width: 1024px) and (max-width: 1279px) {\n      ', '\n    }\n  '], ['\n    @media (min-width: 1024px) and (max-width: 1279px) {\n      ', '\n    }\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['\n    @media (min-width: 1024px) {\n      ', '\n    }\n  '], ['\n    @media (min-width: 1024px) {\n      ', '\n    }\n  ']),
    _templateObject8 = _taggedTemplateLiteral(['\n    @media (min-width: 1280px) and (max-width: 1439px) {\n      ', '\n    }\n  '], ['\n    @media (min-width: 1280px) and (max-width: 1439px) {\n      ', '\n    }\n  ']),
    _templateObject9 = _taggedTemplateLiteral(['\n    @media (min-width: 1280px) {\n      ', '\n    }\n  '], ['\n    @media (min-width: 1280px) {\n      ', '\n    }\n  ']),
    _templateObject10 = _taggedTemplateLiteral(['\n    @media (min-width: 1440px) {\n      ', '\n    }\n  '], ['\n    @media (min-width: 1440px) {\n      ', '\n    }\n  ']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { css } from 'styled-components';

var mediaQueries = {
  phoneOnly: function phoneOnly() {
    return css(_templateObject, css.apply(undefined, arguments));
  },
  phonePortrait: function phonePortrait() {
    return css(_templateObject2, css.apply(undefined, arguments));
  },
  phoneLandscape: function phoneLandscape() {
    return css(_templateObject3, css.apply(undefined, arguments));
  },
  tabletOnly: function tabletOnly() {
    return css(_templateObject4, css.apply(undefined, arguments));
  },
  tabletUp: function tabletUp() {
    return css(_templateObject5, css.apply(undefined, arguments));
  },
  desktopOnly: function desktopOnly() {
    return css(_templateObject6, css.apply(undefined, arguments));
  },
  desktopUp: function desktopUp() {
    return css(_templateObject7, css.apply(undefined, arguments));
  },
  bigDesktopOnly: function bigDesktopOnly() {
    return css(_templateObject8, css.apply(undefined, arguments));
  },
  bigDesktopUp: function bigDesktopUp() {
    return css(_templateObject9, css.apply(undefined, arguments));
  },
  biggerDesktopUp: function biggerDesktopUp() {
    return css(_templateObject10, css.apply(undefined, arguments));
  }
};

export default mediaQueries;